import 'twin.macro'
import 'styled-components/macro'
import { marketingTypographyConfig } from '@getcircuit/tailwind/marketingTypography'
import { ClassName, LiBox, Spec } from './Typography'

export const MarketingTypography = () => {
  return (
    <div tw="space-y-8">
      <h2 tw="text-heading-default">Marketing Typography (Website)</h2>
      <ul
        css={`
          grid-template-rows: repeat(4, minmax(0, 1fr));
        `}
        tw="grid grid-flow-col gap-4"
      >
        <LiBox tw="h-80">
          <div tw="text-title-large-website">Title-large</div>
          <ClassName>.text-title-large-website (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['title-large'].desktop}
          />
          <ClassName>.text-title-large-website (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['title-large'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-title-medium-website">Title-medium</div>
          <ClassName>.text-title-medium-website (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['title-medium'].desktop}
          />
          <ClassName>.text-title-medium-website (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['title-medium'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-title-small-website">Title-small</div>
          <ClassName>.text-title-small-website (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['title-small'].desktop}
          />
          <ClassName>.text-title-small-website (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['title-small'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-heading-website">Heading</div>
          <ClassName>.text-heading-website (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.website['heading'].desktop} />
          <ClassName>.text-heading-website (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.website['heading'].mobile} />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-subheading-website">Subheading</div>
          <ClassName>.text-subheading-website (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['subheading'].desktop}
          />
          <ClassName>.text-subheading-website (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['subheading'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-description-large-website">Description-large</div>
          <ClassName>.text-description-large-website (Desktop)</ClassName>
          <Spec
            config={
              marketingTypographyConfig.website['description-large'].desktop
            }
          />
          <ClassName>.text-description-large-website (Mobile)</ClassName>
          <Spec
            config={
              marketingTypographyConfig.website['description-large'].mobile
            }
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-description-medium-website">Description-medium</div>
          <ClassName>.text-description-medium-website (Desktop)</ClassName>
          <Spec
            config={
              marketingTypographyConfig.website['description-medium'].desktop
            }
          />
          <ClassName>.text-description-medium-website (Mobile)</ClassName>
          <Spec
            config={
              marketingTypographyConfig.website['description-medium'].mobile
            }
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-button-cta-website">Button-cta</div>
          <ClassName>.text-button-cta-website (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['button-cta'].desktop}
          />
          <ClassName>.text-button-cta-website (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['button-cta'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-price-website">Price</div>
          <ClassName>.text-price-website (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.website['price'].desktop} />
          <ClassName>.text-price-website (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.website['price'].mobile} />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-body-website">Body</div>
          <ClassName>.text-body-website (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.website['body'].desktop} />
          <ClassName>.text-body-website (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.website['body'].mobile} />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-uppercase-website">Uppercase</div>
          <ClassName>.text-uppercase-website (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['uppercase'].desktop}
          />
          <ClassName>.text-uppercase-website (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.website['uppercase'].mobile}
          />
        </LiBox>
      </ul>
      <hr />
      <h2 tw="text-heading-default">Marketing Typography (Blog)</h2>
      <ul
        css={`
          grid-template-rows: repeat(5, minmax(0, 1fr));
        `}
        tw="grid grid-flow-col gap-4"
      >
        <LiBox tw="h-80">
          <div tw="text-article-title-blog">Article-title</div>
          <ClassName>.text-article-title-blog (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['article-title'].desktop}
          />
          <ClassName>.text-article-title-blog (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['article-title'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-article-description-blog">Article-description</div>
          <ClassName>.text-article-description-blog (Desktop)</ClassName>
          <Spec
            config={
              marketingTypographyConfig.blog['article-description'].desktop
            }
          />
          <ClassName>.text-article-description-blog (Mobile)</ClassName>
          <Spec
            config={
              marketingTypographyConfig.blog['article-description'].mobile
            }
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-section-title-blog">Section-title</div>
          <ClassName>.text-section-title-blog (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['section-title'].desktop}
          />
          <ClassName>.text-section-title-blog (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['section-title'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-paragraph-title-blog">Paragraph-title</div>
          <ClassName>.text-paragraph-title-blog (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['paragraph-title'].desktop}
          />
          <ClassName>.text-paragraph-title-blog (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['paragraph-title'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-leading-content-blog">Leading-content</div>
          <ClassName>.text-leading-content-blog (Desktop)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['leading-content'].desktop}
          />
          <ClassName>.text-leading-content-blog (Mobile)</ClassName>
          <Spec
            config={marketingTypographyConfig.blog['leading-content'].mobile}
          />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-body-blog">Body</div>
          <ClassName>.text-body-blog (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.blog['body'].desktop} />
          <ClassName>.text-body-blog (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.blog['body'].mobile} />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-body-small-blog">Body-small</div>
          <ClassName>.text-body-small-blog (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.blog['body-small'].desktop} />
          <ClassName>.text-body-small-blog (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.blog['body-small'].mobile} />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-quote-blog">Quote</div>
          <ClassName>.text-quote-blog (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.blog['quote'].desktop} />
          <ClassName>.text-quote-blog (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.blog['quote'].mobile} />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-info-blog">Info</div>
          <ClassName>.text-info-blog (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.blog['info'].desktop} />
          <ClassName>.text-info-blog (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.blog['info'].mobile} />
        </LiBox>
        <LiBox tw="h-80">
          <div tw="text-tag-blog">Tag</div>
          <ClassName>.text-tag-blog (Desktop)</ClassName>
          <Spec config={marketingTypographyConfig.blog['tag'].desktop} />
          <ClassName>.text-tag-blog (Mobile)</ClassName>
          <Spec config={marketingTypographyConfig.blog['tag'].mobile} />
        </LiBox>
      </ul>
    </div>
  )
}
